enum ModoEnum {
  Normal = 1,
  IraniFob = 2,
}

export default ModoEnum
